// GENERATED by scripts/build-icons.mjs from icons/moon-star.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const MoonStar = createIcon('moon-star', [
  ['path', { d: "M18 5h4" }],
  ['path', { d: "M20 3v4" }],
  ['path', { d: "M20.985 12.486a9 9 0 1 1-9.473-9.472c.405-.022.617.46.402.803a6 6 0 0 0 8.268 8.268c.344-.215.825-.004.803.401" }],
])
